import { render, staticRenderFns } from "./SectionReportDetails.vue?vue&type=template&id=7fc54f20&"
import script from "./SectionReportDetails.vue?vue&type=script&lang=js&"
export * from "./SectionReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports